const CORREIOS_SERVICE = {
  SEDEX_10: '03158',
  SEDEX: '03220',
  PAC: '03298',
} as const

type CorreiosEnum = typeof CORREIOS_SERVICE

export const logisticsMethods = {
  '03158': 'SEDEX 10',
  '03220': 'SEDEX',
  '03298': 'PAC',
} satisfies {
  [code in CorreiosEnum[keyof CorreiosEnum]]: string
}
